// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-container {
  width: 120px;
  height: 102px;
  margin-top: 50px;
  margin-bottom: 150px;
}`, "",{"version":3,"sources":["webpack://./src/components/LoginForm/LogoDiv.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;AACJ","sourcesContent":[".logo-container {\r\n    width: 120px;\r\n    height: 102px;\r\n    margin-top: 50px;\r\n    margin-bottom: 150px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
